import Http from "./http"; // needs this file in the same directory
import { The_Ability } from "../store/index";

// const
export default {

  create(done_item) {
    let {photo_compressed, ...di} = done_item
    if (photo_compressed && photo_compressed.length && Array.isArray(photo_compressed)) {
      photo_compressed = photo_compressed.filter(pc=> !pc.id && pc.data)
    }
    return Http.post(`/ghost_execution_items`, {
      done_item: {
        ...di,
        photo_compressed
      }
    },
    {
      headers: {authorization: 'true'}
    },)
  },

  update(done_item) {
    let {photo_compressed, ...di} = done_item
    if (photo_compressed && photo_compressed.length && Array.isArray(photo_compressed)) {
      photo_compressed = photo_compressed.filter(pc=> (!pc.id && pc.data) || (typeof(pc)=='string'))
    }
    return Http.put(`/ghost_execution_items/${done_item.id}`, {
      done_item: {
        ...di,
        photo_compressed
      }
    },
    {
      headers: {authorization: 'true'}
    })
  },

};
